module.exports = __webpack_public_path__ + "static/img/banner.743c8b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/banner.jpg
// module id = HZ8Z
// module chunks = 0